import { React, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import PageSearch from "./pages/PageSearch"
import PageLogout from "./pages/PageLogout"
import PageLoginError from "./pages/PageLoginError"
import {
	PageDocuments,
	PageBuild,
	PageDashboard,
	PageBifrost,
	PageCaseDetails,
	PageExtractDetails,
	PageUploadDetails,
	PageKbmakingDetails,
	PagePIIExtractDetails,
	PageGeneratedSummaryDetails,
} from "./pages"
import PageTimeline from "./pages/CreateTimeline/PageTimeline"
import { msalConfig } from "./config/authConfig"
import PageLoginNew from "./pages/PageLoginNew"
import PageViewer from "./pages/PageViewer"
import { Router, Route, Switch } from "react-router-dom"
import { requestSources } from "./actions/sourcesActions"
import PageFAQ from "./pages/PageFAQ"
import Pdf from "./pages/PagePdf"
import DownloadsPage from "./pages/PageDownloads"
import PageAdminModule from "./pages/PageAdminModule"
import PageUserManagement from "./pages/PageUserManagement"
import { ROUTES } from "./utils"
import ProtectedRoute from "./config/ProtectedRoute"

//Redux
import { Provider } from "react-redux"
import store from "./store"
import { history } from "./helpers/history"

import { MsalProvider } from "@azure/msal-react"
import { PublicClientApplication } from "@azure/msal-browser"
import { requestCustomTags } from "./actions/customTagsActions"
import { ThemeProvider, createTheme, makeStyles } from "@material-ui/core/styles"
import ThemeDark from "./themes/theme-dark.json"
import ThemeLight from "./themes/theme-light.json"
import CssBaseline from "@material-ui/core/CssBaseline"
import PageNotFound from "./pages/PageNotFound"
import PageBilling from "./pages/PageBilling"
import PageForgotPassword from "./pages/PageForgotPassword"
import PageResetPassword from "./pages/PageResetPassword"

const pca = new PublicClientApplication(msalConfig)

function MainContent() {
	return (
		<Router history={history}>
			<Provider store={store}>
				<Switch>
					<Route exact path="/" component={PageLoginNew} />
					<Route exact path={ROUTES.FORGOT_PASSWORD} component={PageForgotPassword} />
					<Route exact path={ROUTES.RESET_PASSWORD} component={PageResetPassword} />
					<ProtectedRoute exact path={ROUTES.DASHBOARD} component={PageDashboard} />
					<ProtectedRoute exact path="/search" component={PageSearch} />
					<ProtectedRoute exact path="/build-concept/:jobId?" permissions="Concept_Get" component={PageBuild} />
					<ProtectedRoute exact path="/create-timeline/:jobId?" permissions="Search_Execute" component={PageTimeline} />
					<ProtectedRoute exact path="/view-documents/:jobId?" permissions="Search_Get" component={PageDocuments} />
					<ProtectedRoute exact path={ROUTES.BIFROST} permissions="Bifrost_Case_Get" component={PageBifrost} />
					<ProtectedRoute exact path={ROUTES.CASE_DETAILS} permissions="Bifrost_Case_Get" component={PageCaseDetails} />
					<ProtectedRoute exact path={ROUTES.EXTRACT_DETAILS} permissions="Bifrost_Case_Get" component={PageExtractDetails} />
					<ProtectedRoute exact path={ROUTES.UPLOAD_DETAILS} permissions="Bifrost_Case_Get" component={PageUploadDetails} />
					<ProtectedRoute exact path={ROUTES.KBMAKING_DETAILS} permissions="Bifrost_Case_Get" component={PageKbmakingDetails} />
					<ProtectedRoute exact path={ROUTES.PII_DETAILS} permissions="Bifrost_Case_Get" component={PagePIIExtractDetails} />
					<ProtectedRoute
						exact
						path={ROUTES.GENSUMMARY_DETAILS}
						permissions="Bifrost_Case_Get"
						component={PageGeneratedSummaryDetails}
					/>
					<ProtectedRoute
						exact
						path={ROUTES.REVERT_EXTRACT_DETAILS}
						permissions="Bifrost_Case_Get"
						component={PageExtractDetails}
					/>
					<ProtectedRoute
						exact
						path={ROUTES.REVERT_PII_DETAILS}
						permissions="Bifrost_Case_Get"
						component={PagePIIExtractDetails}
					/>
					<ProtectedRoute exact path={ROUTES.USER} permissions="User_Get" component={PageUserManagement} />
					<Route exact path={ROUTES.PAGE_NOT_FOUND} component={PageNotFound} />
					<ProtectedRoute exact path={ROUTES.VIEWER_VIEW} component={PageViewer} />
					<ProtectedRoute exact path={ROUTES.BILLING} permissions="Billing_Get" component={PageBilling} />
				</Switch>
			</Provider>
		</Router>
	)
}

function App() {
	const [currentMode, setCurrentMode] = useState("light")
	const mode = useSelector((state) => state.theme.mode)

	const theme = createTheme(currentMode === "dark" ? ThemeDark : ThemeLight)

	useEffect(() => {
		setCurrentMode(mode)
	}, [mode])
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<MsalProvider instance={pca}>
				<MainContent />
			</MsalProvider>
		</ThemeProvider>
	)
}

export default App
